export default "__VITE_ASSET__1e808150__"